import * as React from "react";
import { Navigate, Outlet } from "react-router";

import { useSuppliersAccess } from "@/hooks/use-suppliers-access";

interface Props {
  requireSpendCentre?: boolean;
  requireRenewalCentre?: boolean;
}

export const SuppliersRouteGate: React.FC<Props> = ({ requireSpendCentre = false, requireRenewalCentre = false }) => {
  const { isResolved, hasSuppliers, hasSpendCentre, hasRenewalCentre } = useSuppliersAccess();

  if (!isResolved) return null;
  if (!hasSuppliers || (requireSpendCentre && !hasSpendCentre) || (requireRenewalCentre && !hasRenewalCentre))
    return <Navigate to="/snapshots" replace />;

  return <Outlet />;
};
